import _ from 'lodash'
import moment from 'moment'
const ENTER_KEY = 13

class SearchFormController {
  constructor(
    $uibModal,
    $location,
    alertService,
    $analytics,
    RecordQueryService,
    SearchParametersService,
    SubscriptionService,
    CurrentUserService,
    $httpParamSerializer,
    $scope
  ) {
    this.$uibModal = $uibModal
    this.$location = $location
    this.$httpParamSerializer = $httpParamSerializer
    this.alertService = alertService
    this.$analytics = $analytics
    this.RecordQueryService = RecordQueryService
    this.SearchParametersService = SearchParametersService
    this.SubscriptionService = SubscriptionService
    this.CurrentUserService = CurrentUserService
    this._init()

    $scope.$on('$routeChangeSuccess', this.newSearch.bind(this))
  }

  newSearch(ev, currentUrl, previousUrl) {
    if(!this.RecordQueryService.queryRunning && !_.isEmpty(this.$location.search())) {
      this._runQuery(currentUrl.params)
    }
  }

  _init() {
    this.clearSearchError()
    this._resetAlertStatus()
    this.currentDate = moment().format('YYYY-MM-DD')
    this.viewState = {}
    this.advanced = {}
    this.quick = {}
    this.entity = {}
    this.multiSelect = {
      displaySettings: {
        scrollable              : true,
        scrollableHeight        : '275px',
        buttonClasses           : 'multi-select-dropdown btn btn-default dropdown-toggle doc-type-button',
        smartButtonMaxItems     : 2,
        smartButtonTextConverter: this.shortenNames.bind(this)
      },

      buttonTextSettings: {
        buttonDefaultText: 'All Documents'
      }
    }

    this.selectedDocs = []
    this.docTypeNames = []

    // get searchable states based on subscription then init with defaults based
    // on that
    this.SearchParametersService.searchableStates()
      .then(() => this._initParams())
  }

  // search parameters are stored in a service so that they can persit.
  // a common use case for a user is to search and then follow the search
  // results to other parts of the application. When they come back to the
  // search form we want to populate the form with the model values from the
  // previous search
  _initParams() {
    const searchParams = this.SearchParametersService
    const noPreviousSearch = searchParams.isEmpty || searchParams.fromQuickLink

    if (noPreviousSearch) {
      searchParams.fromQuickLink = false
      const urlParams = this.$location.search()
      const autoSearch = urlParams.autoSearch

      this._initAdvancedParameters(urlParams)
      this._initEntityParameters(urlParams)
      this._initQuickParameters(urlParams)

      searchParams.viewState = {}
      searchParams.viewState.searchType = 'advancedSearch'
      searchParams.viewState.dateType = 'quick'
      searchParams.viewState.dateFilterType = 'received'

      this.resetModels()
      if (autoSearch) {
        if (searchParams.quick.value != null) {
          this.runQuick()
        } else {
          this.run()
        }
      }
    } else {
      this.resetModels()
    }
  }

  _initAdvancedParameters(urlParams) {
    this.advanced = _(urlParams)
      .omit(_.isEmpty)
      .omit('autoSearch', _.keys(this.quickAttributes))
      .defaults(this.SearchParametersService.defaultCriteria)
      .value()

    this.SearchParametersService.advanced = this.advanced
  }

  _initEntityParameters(urlParams) {
    this.entity = _.clone(this.SearchParametersService.defaultEntityCriteria)
    this.SearchParametersService.entity = this.entity
    this._getUrlParams(
      this.SearchParametersService.entityAttributes,
      this.entity,
      urlParams
    )
  }

  _initQuickParameters(urlParams) {
    this.quick = _.clone(this.SearchParametersService.defaultQuickCriteria)
    this.SearchParametersService.quick = this.quick
    this._getUrlParams(
      this.SearchParametersService.quickAttributes,
      this.quick,
      urlParams
    )
  }

  _getUrlParams(attributes, criteriaHolder, urlParams) {
    const matchedUrlParams = _.pick(urlParams, _.keys(attributes))
    const key = _.keys(matchedUrlParams)[0]
    if (key != undefined) {
      criteriaHolder.attribute = key
      criteriaHolder.value = matchedUrlParams[key]
    }
  }

  focusNextInput($item, $model, $label, $event){
    const $currentEl = $($event.currentTarget)
    const $nextInputIndex = $(':input').index($currentEl) + 1
    const $nextInputEl = $(':input:eq(' + $nextInputIndex + ')')
    $currentEl
      .closest("form")
      .find($nextInputEl)
      .focus()
      .select()
  }

  resetModels() {
    const searchParams = this.SearchParametersService

    this.viewState         = _.clone(searchParams.viewState)
    this.advanced          = _.clone(searchParams.advanced)
    this.quick             = _.clone(searchParams.quick)
    this.entity            = _.clone(searchParams.entity)
    this.docTypeNames      = this.selectedStateDoctypeNames
    this.selectedDocs      = this._parseSelectedDocs(searchParams.advanced)
    this.currentDateChoice = searchParams.advanced.currentDateChoice
  }

  toNames(dropDownItem) {
    return dropDownItem.id
  }

  _parseSelectedDocs(advancedSearchParams) {
    const docs = [].concat(advancedSearchParams.typeOfDocument)

    return _(docs)
            .flatten()
            .without('all')
            .value()
            .map(this.toDropdownLabels)
  }

  commitModels() {
    const searchParams = this.SearchParametersService
    this.advanced.typeOfDocument = _(this.selectedDocs).map(this.toNames).value()
    this.advanced.selectedDocs = this.selectedDocs
    searchParams.viewState = this.viewState
    searchParams.advanced  = this.advanced
    searchParams.quick     = this.quick
    searchParams.entity    = this.entity
  }

  get queryRunning() {
    return this.RecordQueryService.queryRunning
  }

  get errorMessage() {
    return this.RecordQueryService.errorMessage
  }

  closeStatus() {
    this.showStatus = false
  }

  timeIntervals(value, interval) {
    const dateToSet = moment()
      .subtract(value, interval)
      .format('YYYY-MM-DD')
    if (this.viewState.dateFilterType === 'event') {
      this.advanced.startDate = dateToSet
      this.advanced.endDate = undefined
    } else {
      this.advanced.addedAtStart = dateToSet
      this.advanced.addedAtEnd = undefined
    }
    this.currentDateChoice = value + " " + interval
    this.advanced.currentDateChoice = this.currentDateChoice
  }

  run() {
    this._resetAlertStatus()
    this.commitModels()
    const serializedParams = this.$httpParamSerializer(this.SearchParametersService.queryParams)
    this.$location.search(serializedParams)
  }

  // Ideally, this would be a separate controller and probably should be
  // after the next iteration.
  runQuick() {
    this.viewState.searchType = 'quickSearch'
    this._resetAlertStatus()
    this.commitModels()

    const serializedParams = this.$httpParamSerializer(this.SearchParametersService.quickParams)
    this.$location.search(serializedParams)
  }

  enterQuickSearch(e) {
    if(!this.queryRunning && e.which === ENTER_KEY) {
      this.runQuick()
    }
  }

  enterSearch(e) {
    if(!this.queryRunning && e.which === ENTER_KEY) {
      this.run()
    }
  }

  changeStateChoice(state) {
    this.clearCriteria()
    this.advanced.state = state
    this.docTypeNames = this.selectedStateDoctypeNames
  }

  switchDateFilterTypeTo(type) {
    if (type === 'received') {
      this.advanced.addedAtStart = this.advanced.startDate
      this.advanced.addedAtEnd = this.advanced.endDate
      this._clearDateTypeFilter('event')
    } else if (type === 'event') {
      this.advanced.startDate = this.advanced.addedAtStart
      this.advanced.endDate = this.advanced.addedAtEnd
      this._clearDateTypeFilter('received')
    }
  }

  _clearDateTypeFilter(type) {
    if (type === 'event') {
      this.advanced.startDate = undefined
      this.advanced.endDate = undefined
    } else if (type === 'received') {
      this.advanced.addedAtStart = undefined
      this.advanced.addedAtEnd = undefined
    }
  }

  get canAddAlert() {
    return this.RecordQueryService.canAddAlert
  }
  userHasState(state) {
    return _.includes(this.states, state)
  }

  get userHasAtla() {
    return this.CurrentUserService.hasUserRole('rav-u')
  }

  get disableNineSpot() {
    const disabled = !_.every([
      this.advanced.section,
      this.advanced.township,
      this.advanced.range,
      this.advanced.meridian,
      this.advanced.meridian !== this.SearchParametersService.searchParameterMultiValue
    ], v => !!v)
    this.advanced.nineSpot = disabled ? false : this.advanced.nineSpot
    return disabled
  }

  importMultipleLegals() {
    this.$analytics.eventTrack('Import Multiple Legals Open', {})
    var modalInstance = this.$uibModal.open({
      animation: true,
      templateUrl: 'multiple-legal-modal.partial.html',
      controller: 'MultipleValuesModalController',
      controllerAs: 'mlm',
      resolve: {
        values: () => this.advanced.legals,
        validLength: () => 13
      }
    })
    modalInstance.result.then((result) => this.addMultipleLegalCriteria(result))
  }

  addMultipleLegalCriteria(legals) {
    this.$analytics.eventTrack('Import Multiple Legals Added',
        {legals: legals.values.toString(), length: legals.values.length.toString()})
    this.advanced.legals = legals.values
  }

  importMultipleApis() {
    this.$analytics.eventTrack('Import Multiple Apis Open', {})
    var modalInstance = this.$uibModal.open({
      animation: true,
      templateUrl: 'multiple-apis-modal.partial.html',
      controller: 'MultipleValuesModalController',
      controllerAs: 'mam',
      resolve: {
        values: () => this.quick.value,
        validLength: () => 10
      }
    })
    modalInstance.result.then((result) => this.addMultipleApiCriteria(result))
  }

  get multipleApisImported() {
    return _.isArray(this.quick.value) && this.quick.attribute === 'apiNumber'
  }

  addMultipleApiCriteria(apis) {
    this.$analytics.eventTrack('Import Multiple Apis Added',
        {apis: apis.values.toString(), length: apis.values.length.toString()})
    this.quick.value = apis.values
  }

  clearCriteria() {
    this.RecordQueryService.cancelPendingQueries()
    this.$location.search('')
    this._resetAlertStatus()
    this.advanced = _.clone(this.SearchParametersService.defaultCriteria)
    this.entity = _.clone(this.SearchParametersService.defaultEntityCriteria)
    this.quick = _.clone(this.SearchParametersService.defaultQuickCriteria)
    this.currentDateChoice = null
    this.selectedDocs = []
  }

  _runQuery(params, type = 'full') {
    if (!this.RecordQueryService.queryRunning) {
      const query = this.RecordQueryService.query(params)
    }
  }

  _resetAlertStatus() {
    this.status = {
      type: null,
      msg: ''
    }
    this.showStatus = false
  }

  clearSearchError() {
    this.RecordQueryService.errorMessage = ''
  }

  openAlertModal() {
    var modalInstance = this.$uibModal.open({
      animation: true,
      templateUrl: 'add-alert-modal.partial.html',
      controller: 'AddAlertModalController',
      controllerAs: 'newAlert',
      size: 'sm'
    })

    modalInstance.result.then(this.addAlert.bind(this))
  }

  addAlert(alertParams) {
    if (alertParams) {
      this.alertService.addAlert(
        alertParams.title,
        this.RecordQueryService.queryParams,
        this._onAddAlertSuccess.bind(this),
        this._onAddAlertFail.bind(this)
      )
    }
  }

  _onAddAlertSuccess() {
    this.status.type = 'success'
    this.status.msg = 'Your alert has been successfully added.'
    this.showStatus = true
  }

  _onAddAlertFail() {
    this.status.type = 'danger'
    this.status.msg = 'Sorry, a problem occurred when adding the alert.'
    this.showStatus = true
  }

  get states() {
    return this.SearchParametersService.states
  }

  get defaultQuickCriteria() {
    return this.SearchParametersService.defaultQuickCriteria
  }

  get defaultEntityCriteria() {
    return this.SearchParametersService.defaultEntityCriteria
  }

  get counties() {
    return this.SearchParametersService.allCounties[this.advanced.state]
  }

  get meridians() {
    return this.SearchParametersService.allMeridians[this.advanced.state]
  }

  get sections() {
    return this.SearchParametersService.allSections[this.advanced.state]
  }

  get townships() {
    return this.SearchParametersService.allTownships[this.advanced.state][this.advanced.meridian]
  }

  get ranges() {
    return this.SearchParametersService.allRanges[this.advanced.state][this.advanced.meridian]
  }

  get docTypes() {
    return this.SearchParametersService.allDocTypes[this.advanced.state]
  }

  toDropdownLabels(name) {
    return {id: name, label: name}
  }

  get selectedStateDoctypeNames() {
    return _(this.docTypes)
              .keys()
              .without('all')
              .sort()
              .map(this.toDropdownLabels)
              .value()
  }

  shortenNames(itemText, originalItem) {
    if (itemText === 'Cert of Comp & Trans Authority') {
      return 'Cert of Comp'
    }

    return itemText
  }

  get quickAttributes() {
    return this.SearchParametersService.quickAttributes
  }

  get entityAttributes() {
    return this.SearchParametersService.entityAttributes
  }
}

SearchFormController.$inject = [
  '$uibModal',
  '$location',
  'AlertService',
  '$analytics',
  'RecordQueryService',
  'SearchParametersService',
  'SubscriptionService',
  'CurrentUserService',
  '$httpParamSerializer',
  '$scope'
]

export default SearchFormController
